import { useState, useRef, useCallback, forwardRef, memo } from "react";

import TranslationText from "@Components/Utilities/TranslationText";
import BaseMap from "@Components/Maps/BaseMap";

const LocationMap = memo(
  forwardRef((props, ref) => {
    const [isOpen, setIsOpen] = useState(props.isOpen);
    const [isToggling, setIsToggling] = useState(false);
    const baseMapRef = useRef(null);

    const getIconClass = () => {
        if (isOpen) {
            return 'fas fa-minus';
        } else {
            return 'fas fa-chevron-right';
        }
    };

    const toggleOpen = useCallback((e) => {
        e.preventDefault();
        // Prevent odd toggling behavior switching from mobile to desktop resolution
        if (!isToggling) {
          setIsToggling(true);
          setIsOpen((prev) => !prev);
          setTimeout(() => setIsToggling(false), 300);
        }
      }, [isToggling]);

    return (
      <details open={isOpen} onToggle={toggleOpen}>
        <summary className="geographic-search-header">
          <h2 className="geographic-search-header-text">
            <TranslationText tKey="sandhills.tradesites.mvc.usegeographicsearch" />
          </h2>
          <i className={getIconClass()}></i>
        </summary>
        <div className="map-container">
          <BaseMap
            ref={ref || baseMapRef}
            locations={props.locations}
            listings={props.listings}
            listingMapData={props.listingMapData}
            flightPaths={props.flightPaths}
            currentUser={props.currentUser}
            defaultCenter={props.defaultCenter}
            defaultZoom={props.defaultZoom}
            onLocationChange={props.onLocationChange}
            disableAutoCentering={props.disableAutoCentering}
            enableGeolocation={props.enableGeolocation}
            onRequestQuote={props.onRequestQuote}
            onEmailSeller={props.onEmailSeller}
          />
        </div>
      </details>
    );
  }),
);

export default LocationMap;
